import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import ErrorDisplay from "../../../../../components/UI/ErrorDisplay";
import useGetHistory from "../../../../../CustomHooks/useAxios/useGetHistory";
import { setError } from "../../../../../redux/dataSlice";
import VehicleHistoryForm from "./VehicleHistoryForm";
import VehicleHistoryContainer from "./VehicleHistoryContainer";

function VehicleHistoryContent({ setupData }) {
  const dispatch = useDispatch();

  const historyError = useSelector((state) => state.data.error);
  const historyErrMsg = useSelector((state) => state.data.errMessage);
  const { getHistory, historyLoaded, isSucceed, setIsSucceed } =
    useGetHistory();

  return (
    <>
      {historyError && (
        <ErrorDisplay
          message={historyErrMsg}
          closeAction={() => dispatch(setError("false"))}
        />
      )}
      <div className="cy-history-wrap">
        <VehicleHistoryForm
          setupData={setupData}
          historyLoaded={historyLoaded}
          getHistory={getHistory}
          setIsSucceed={setIsSucceed}
          isSucceed={isSucceed}
          setError={setError}
          historyError={historyError}
        />
        <VehicleHistoryContainer isSucceed={isSucceed} />
      </div>
    </>
  );
}

export default VehicleHistoryContent;
